const customerClubPopup = document.getElementById('js-customer-club-popup')

if (customerClubPopup && customerClubPopup.dataset.initialised !== 'true') {
  customerClubPopup.dataset.initialised = 'true'
  const dialog = customerClubPopup.querySelector('.customer-club-popup__dialog')
  const backdrop = customerClubPopup.querySelector('.customer-club-popup__backdrop')
  const teaser = customerClubPopup.querySelector('.customer-club-popup__teaser')
  const teaserWrap = customerClubPopup.querySelector('.customer-club-popup__teaser-wrap')
  const closeButtons = customerClubPopup.querySelectorAll('.js-customer-club-popup-close')
  const teaserDismissButtons = customerClubPopup.querySelectorAll('.js-customer-club-teaser-dismiss')
  const form = customerClubPopup.querySelector('form')
  const formError = customerClubPopup.querySelector('.customer-club-popup__form-error')
  const captchaPanel = customerClubPopup.querySelector('.customer-club-popup__captcha')
  const successPanel = customerClubPopup.querySelector('.customer-club-popup__success')
  const successContinue = customerClubPopup.querySelector('.js-customer-club-success-continue')
  const teaserStorageKey = 'kabookiCustomerClubTeaserDismissedUntilV2'
  const popupSnoozeStorageKey = 'kabookiCustomerClubPopupSnoozedUntilV1'
  const autoOpenedSessionKey = 'kabookiCustomerClubPopupAutoOpenedV1'
  const engagedSecondsSessionKey = 'kabookiCustomerClubEngagedSecondsV1'
  const productPathsSessionKey = 'kabookiCustomerClubProductPathsV1'
  const interactionSessionKey = 'kabookiCustomerClubInteractedV1'
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const teaserTransitionDuration = reducedMotion ? 0 : 220
  const successTransitionDuration = reducedMotion ? 0 : 180
  const autoOpenEnabled = customerClubPopup.dataset.autoOpen === '1'
  const manualOnly = customerClubPopup.dataset.manualOnly === '1'
  const readPositiveInteger = (value, fallback) => {
    const parsed = Number.parseInt(value, 10)
    return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback
  }
  const engagementSeconds = readPositiveInteger(customerClubPopup.dataset.engagementSeconds, 45)
  const scrollPercent = Math.min(100, readPositiveInteger(customerClubPopup.dataset.scrollPercent, 50))
  const requiredProductViews = readPositiveInteger(customerClubPopup.dataset.productViews, 2)
  const productDelaySeconds = readPositiveInteger(customerClubPopup.dataset.productDelaySeconds, 10)
  const exitIntentSeconds = readPositiveInteger(customerClubPopup.dataset.exitIntentSeconds, 15)
  const popupSnoozeDays = readPositiveInteger(customerClubPopup.dataset.popupSnoozeDays, 7)
  let returnFocus = null
  let originalBodyPaddingRight = null
  let originalBodyPaddingRightPriority = ''
  let activeSignupStep = form
  let pageEngagedSeconds = 0
  let maximumScrollPercent = 0
  let signupTrackingAttempt = null

  const readStoredTime = (key) => {
    try {
      return Number.parseInt(window.localStorage.getItem(key), 10) || 0
    } catch (error) {
      return 0
    }
  }

  const storeUntil = (key, time) => {
    try {
      window.localStorage.setItem(key, String(time))
    } catch (error) {
      // Storage may be unavailable in privacy modes; the interaction should still work.
    }
  }

  const readSessionValue = (key) => {
    try {
      return window.sessionStorage.getItem(key)
    } catch (error) {
      return null
    }
  }

  const storeSessionValue = (key, value) => {
    try {
      window.sessionStorage.setItem(key, String(value))
    } catch (error) {
      // Session storage can be unavailable; automatic rules still work on the current page.
    }
  }

  const readSessionNumber = (key) => Number.parseInt(readSessionValue(key), 10) || 0

  const readProductPaths = () => {
    try {
      const paths = JSON.parse(readSessionValue(productPathsSessionKey) || '[]')
      return Array.isArray(paths) ? paths.filter((path) => typeof path === 'string') : []
    } catch (error) {
      return []
    }
  }

  const registerProductView = () => {
    if (!document.querySelector('.product-page')) return readProductPaths()
    const paths = readProductPaths()
    if (!paths.includes(window.location.pathname)) {
      paths.push(window.location.pathname)
      storeSessionValue(productPathsSessionKey, JSON.stringify(paths.slice(-20)))
    }
    return paths
  }

  const showUspAlternative = () => {
    teaserWrap.hidden = true
    document.body.classList.add('customer-club-usp-visible')
    document.querySelectorAll('.js-customer-club-usp').forEach((item) => { item.hidden = false })
    const mobileUsps = document.querySelector('.navigation__usps--mobile')
    const mobileSwiper = mobileUsps?.swiper
    if (mobileSwiper) {
      mobileSwiper.update()
    }
    document.dispatchEvent(new CustomEvent('kabooki:club-usp:shown'))
  }

  const sendEvent = (action) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'customer_club_popup',
      customer_club_popup_action: action,
    })
  }

  const focusableElements = () => Array.from(dialog.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )).filter((element) => !element.hidden && element.offsetParent !== null)

  const isOpen = () => !dialog.hidden

  const hasBlockingOverlay = () => {
    const otherDialogOpen = Array.from(document.querySelectorAll('[role="dialog"]')).some(
      (candidate) => candidate !== dialog && !candidate.hidden && candidate.getAttribute('aria-hidden') !== 'true'
    )
    return otherDialogOpen || Boolean(document.querySelector(
      '.mini-basket--active, .search--active, .navigation__mega--visible, .wishlist-auth.is-open, .mobile-info-panel.is-open, .mobile-favourites-panel.is-open, .mobile-shop-switch.is-open'
    ))
  }

  const canOpenAutomatically = () => (
    autoOpenEnabled &&
    !manualOnly &&
    !isOpen() &&
    document.visibilityState === 'visible' &&
    readSessionValue(autoOpenedSessionKey) !== '1' &&
    readStoredTime(popupSnoozeStorageKey) <= Date.now() &&
    readStoredTime(teaserStorageKey) <= Date.now() &&
    !hasBlockingOverlay()
  )

  const lockPageScroll = () => {
    if (document.body.classList.contains('customer-club-popup-open')) return

    const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth)
    originalBodyPaddingRight = document.body.style.getPropertyValue('padding-right')
    originalBodyPaddingRightPriority = document.body.style.getPropertyPriority('padding-right')

    if (scrollbarWidth > 0) {
      const bodyPaddingRight = Number.parseFloat(window.getComputedStyle(document.body).paddingRight) || 0
      document.body.style.setProperty('padding-right', `${bodyPaddingRight + scrollbarWidth}px`)
    }

    document.body.classList.add('customer-club-popup-open')
  }

  const unlockPageScroll = () => {
    document.body.classList.remove('customer-club-popup-open')

    if (originalBodyPaddingRight) {
      document.body.style.setProperty(
        'padding-right',
        originalBodyPaddingRight,
        originalBodyPaddingRightPriority
      )
    } else {
      document.body.style.removeProperty('padding-right')
    }

    originalBodyPaddingRight = null
    originalBodyPaddingRightPriority = ''
  }

  const openPopup = (source = 'teaser') => {
    if (isOpen()) return
    storeSessionValue(autoOpenedSessionKey, '1')
    returnFocus = document.activeElement
    dialog.hidden = false
    backdrop.hidden = false
    dialog.setAttribute('aria-hidden', 'false')
    teaser.setAttribute('aria-expanded', 'true')
    lockPageScroll()
    window.requestAnimationFrame(() => customerClubPopup.classList.add('is-open'))
    focusableElements()[0]?.focus()
    sendEvent(`${source}_open`)
  }

  const closePopup = () => {
    if (!isOpen()) return
    storeUntil(
      popupSnoozeStorageKey,
      Date.now() + popupSnoozeDays * 24 * 60 * 60 * 1000
    )
    customerClubPopup.classList.remove('is-open')
    dialog.setAttribute('aria-hidden', 'true')
    teaser.setAttribute('aria-expanded', 'false')
    window.setTimeout(() => {
      dialog.hidden = true
      backdrop.hidden = true
      unlockPageScroll()
    }, 260)
    returnFocus?.focus()
    sendEvent('close')
  }

  const dismissTeaser = () => {
    if (teaserWrap.hidden || teaserWrap.classList.contains('is-dismissing')) return
    const dismissDays = Math.max(1, Number.parseInt(customerClubPopup.dataset.dismissDays, 10) || 30)
    const dismissedUntil = Date.now() + dismissDays * 24 * 60 * 60 * 1000
    storeUntil(teaserStorageKey, dismissedUntil)
    teaserWrap.classList.add('is-dismissing')
    window.setTimeout(showUspAlternative, teaserTransitionDuration)
    sendEvent('teaser_dismiss')
  }

  const setSubmitting = (submittedForm, submitting) => {
    const submitButtons = submittedForm.querySelectorAll('[type="submit"]')
    submittedForm.dataset.submitting = submitting ? 'true' : 'false'
    submittedForm.setAttribute('aria-busy', submitting ? 'true' : 'false')
    submittedForm.classList.toggle('is-submitting', submitting)
    submitButtons.forEach((button) => { button.disabled = submitting })
  }

  const transitionToStep = (nextStep) => {
    const previousStep = activeSignupStep
    nextStep.hidden = false
    nextStep.classList.remove('is-leaving')

    if (!previousStep || previousStep === nextStep) {
      window.requestAnimationFrame(() => nextStep.classList.add('is-visible'))
      nextStep.focus()
      activeSignupStep = nextStep
      return
    }

    previousStep.classList.add('is-leaving')
    window.setTimeout(() => {
      previousStep.hidden = true
      previousStep.classList.remove('is-visible', 'is-leaving')
      window.requestAnimationFrame(() => {
        nextStep.classList.add('is-visible')
        nextStep.focus()
      })
    }, successTransitionDuration)
    activeSignupStep = nextStep
  }

  const showSuccess = () => {
    const storedUntil = Date.now() + 365 * 24 * 60 * 60 * 1000
    storeUntil(teaserStorageKey, storedUntil)
    storeUntil(popupSnoozeStorageKey, storedUntil)
    teaserWrap.hidden = true
    document.body.classList.remove('customer-club-usp-visible')
    document.querySelectorAll('.js-customer-club-usp').forEach((item) => { item.hidden = true })

    if (successPanel) transitionToStep(successPanel)
    else if (activeSignupStep) activeSignupStep.hidden = true

    sendEvent('submit_success')
  }

  const showCaptcha = (responseDocument, responseUrl) => {
    const responseCaptchaForm = responseDocument.querySelector('form.captcha')
    if (!captchaPanel || !responseCaptchaForm) return false

    const captchaForm = document.importNode(responseCaptchaForm, true)
    captchaForm.action = responseUrl || form.action
    captchaForm.querySelectorAll('[onclick]').forEach((element) => element.removeAttribute('onclick'))

    const captchaImage = captchaForm.querySelector('img')
    if (captchaImage) captchaImage.alt = customerClubPopup.dataset.captchaImageAlt || 'Robot verification code'

    const captchaInput = captchaForm.querySelector('input[name="c"]')
    if (captchaInput && !captchaInput.getAttribute('aria-label')) {
      captchaInput.setAttribute('aria-label', captchaInput.placeholder || 'Robot verification code')
    }

    const captchaButtons = captchaForm.querySelectorAll('button')
    captchaButtons[0]?.classList.add('btn--primary')
    if (captchaButtons[1]) {
      captchaButtons[1].type = 'button'
      captchaButtons[1].classList.add('js-customer-club-captcha-refresh')
    }

    captchaPanel.replaceChildren(captchaForm)
    transitionToStep(captchaPanel)
    captchaInput?.focus()
    sendEvent('captcha_view')
    return true
  }

  const getResponseError = (responseDocument) => responseDocument.querySelector(
    '.alert--error, .notification--error, .input-wrapper--error .error, [role="alert"]'
  )?.textContent.trim()

  const submitSignupForm = (submittedForm, submitter = null) => {
    if (submittedForm.dataset.submitting === 'true') return

    if (submittedForm === form) signupTrackingAttempt = window.KabookiClubTracking?.begin('popup')
    setSubmitting(submittedForm, true)
    if (formError) {
      formError.hidden = true
      formError.textContent = ''
    }

    const formData = new FormData(submittedForm)
    if (submitter?.name && !formData.has(submitter.name)) {
      formData.append(submitter.name, submitter.value)
    }

    window.fetch(submittedForm.action || form.action, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => response.text().then((responseHtml) => ({ response, responseHtml })))
      .then(({ response, responseHtml }) => {
        const responseDocument = new DOMParser().parseFromString(responseHtml, 'text/html')

        if (response.ok && responseDocument.querySelector('.user-area__created')) {
          showSuccess()
          const continueToThanks = () => window.location.assign('/club-thank-you')
          if (signupTrackingAttempt) signupTrackingAttempt.confirm(response, responseDocument, continueToThanks)
          else continueToThanks()
          return
        }

        if (response.ok && showCaptcha(responseDocument, response.url)) return

        return Promise.reject(new Error(
          getResponseError(responseDocument) ||
          customerClubPopup.dataset.signupError ||
          'We could not create your membership. Please check your details and try again.'
        ))
      })
      .catch((error) => {
        if (formError) {
          formError.textContent = error.message
          formError.hidden = false
          formError.focus()
        }
        sendEvent('submit_error')
      })
      .then(() => setSubmitting(submittedForm, false))
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('.js-customer-club-teaser-dismiss')) {
      dismissTeaser()
      return
    }
    const button = event.target.closest('.js-customer-club-popup-open')
    if (!button) return
    openPopup(button.closest('.navigation__usp--club') ? 'usp' : 'teaser')
  })
  closeButtons.forEach((button) => button.addEventListener('click', closePopup))
  teaserDismissButtons.forEach((button) => button.addEventListener('click', dismissTeaser))

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault()
      closePopup()
      return
    }
    if (event.key !== 'Tab') return

    const focusable = focusableElements()
    if (!focusable.length) return
    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  })

  form?.addEventListener('submit', (event) => {
    event.preventDefault()
    submitSignupForm(form, event.submitter)
  })

  captchaPanel?.addEventListener('submit', (event) => {
    event.preventDefault()
    submitSignupForm(event.target, event.submitter)
  })

  captchaPanel?.addEventListener('click', (event) => {
    if (!event.target.closest('.js-customer-club-captcha-refresh')) return
    submitSignupForm(form, form.querySelector('[type="submit"]'))
  })

  successContinue?.addEventListener('click', closePopup)

  const teaserDismissedUntil = readStoredTime(teaserStorageKey)
  const productPaths = registerProductView()

  const updateMaximumScroll = () => {
    const scrollableHeight = Math.max(0, document.documentElement.scrollHeight - window.innerHeight)
    const currentPercent = scrollableHeight === 0
      ? 100
      : Math.min(100, Math.round((window.scrollY / scrollableHeight) * 100))
    maximumScrollPercent = Math.max(maximumScrollPercent, currentPercent)
  }

  const recordInteraction = () => storeSessionValue(interactionSessionKey, '1')

  const tryAutomaticOpen = (source) => {
    if (!canOpenAutomatically()) return false
    openPopup(`auto_${source}`)
    return true
  }

  const evaluateInterestRules = () => {
    const totalEngagedSeconds = readSessionNumber(engagedSecondsSessionKey)
    if (productPaths.length >= requiredProductViews && pageEngagedSeconds >= productDelaySeconds) {
      return tryAutomaticOpen('product_interest')
    }
    if (totalEngagedSeconds >= engagementSeconds && maximumScrollPercent >= scrollPercent) {
      return tryAutomaticOpen('engagement')
    }
    return false
  }

  const recordEngagedSecond = () => {
    if (document.visibilityState !== 'visible') return
    pageEngagedSeconds += 1
    storeSessionValue(
      engagedSecondsSessionKey,
      readSessionNumber(engagedSecondsSessionKey) + 1
    )
    evaluateInterestRules()
  }

  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches
  if (autoOpenEnabled && !manualOnly) {
    updateMaximumScroll()
    window.addEventListener('scroll', () => {
      updateMaximumScroll()
      recordInteraction()
      evaluateInterestRules()
    }, { passive: true })
    document.addEventListener('pointerdown', recordInteraction, { passive: true, once: true })
    document.addEventListener('keydown', recordInteraction, { once: true })
    window.setInterval(recordEngagedSecond, 1000)

    if (finePointer) {
      document.addEventListener('mouseout', (event) => {
        const leavingThroughTop = event.clientY <= 0 && !event.relatedTarget
        if (!leavingThroughTop) return
        if (readSessionNumber(engagedSecondsSessionKey) < exitIntentSeconds) return
        if (readSessionValue(interactionSessionKey) !== '1') return
        tryAutomaticOpen('exit_intent')
      })
    }
  }

  window.requestAnimationFrame(() => customerClubPopup.classList.add('is-ready'))

  if (teaserDismissedUntil > Date.now()) showUspAlternative()
}
